import React, { useState } from 'react';
import CascaDeModal from '../shared/CascaDeModal';
import { acaoPrincipal, acaoSecundaria } from '../../design';
import { TONE_BORDER, TONE_SURFACE, TONE_TEXT } from '../../utils/statusColors';

/**
 * LIBERAR A RETENÇÃO E APROVAR, COM MOTIVO (04/11/2026, decisão do Heitor). Desde 07/10/2026 o backend recusa o
 * `finalize?force=true` sem `releaseNote` (400 "a liberação da retenção exige o MOTIVO escrito"), e a tela mandava o
 * force sem motivo: liberar uma retida pela tela não funcionava. O motivo é obrigatório aqui, fica gravado na fatura
 * (approvalHoldReleaseNote, com o autor tirado do token), e a recusa do servidor aparece dentro do modal, com a frase dele.
 */
type Props = {
  codigo: string;
  motivoDaRetencao?: string | null;
  /** O que a tela não conseguiu ler antes (a prévia do empenho), em uma frase. */
  aviso?: string;
  enviando?: boolean;
  erro?: string | null;
  onCancelar: () => void;
  onConfirmar: (motivo: string) => void;
};

/** O campo do motivo da liberação, igual aqui e na confirmação com empenho. */
export function CampoDoMotivoDaLiberacao({ valor, onChange }: { valor: string; onChange: (v: string) => void }) {
  return (
    <div>
      <label htmlFor='motivo-da-liberacao' className='block text-xs text-slate-400 mb-1'>Motivo para liberar a retenção (obrigatório; fica na fatura)</label>
      <textarea id='motivo-da-liberacao' value={valor} onChange={(e) => onChange(e.target.value)} rows={2} maxLength={500}
        className='w-full px-3 py-2 rounded-lg text-sm bg-central-elevado border border-amber-500/60 text-white placeholder:text-slate-500'
        placeholder='ex.: o órgão liberou o pagamento deste mês' />
    </div>
  );
}

export function RecusaDoServidor({ erro }: { erro?: string | null }) {
  if (!erro) return null;
  return <p role='alert' className={`text-sm ${TONE_TEXT.danger}`} data-recusa-da-aprovacao>{erro}</p>;
}

export default function LiberacaoDaRetencao({ codigo, motivoDaRetencao, aviso, enviando, erro, onCancelar, onConfirmar }: Props) {
  const [motivo, setMotivo] = useState('');
  const falta = !motivo.trim();
  return (
    <CascaDeModal
      largura='sm'
      titulo={`Liberar a retenção e aprovar ${codigo}?`}
      onClose={onCancelar}
      temEdicaoNaoSalva={() => !!motivo.trim()}
      corpoClassName='px-5 py-4 space-y-3'
      rodape={
        <>
          <button type='button' onClick={onCancelar} className={`ml-auto px-4 py-2 rounded-lg text-sm ${acaoSecundaria}`}>Cancelar</button>
          <button type='button' onClick={() => onConfirmar(motivo.trim())} disabled={falta || enviando} data-liberar-e-aprovar
            title={falta ? 'Escreva o motivo para liberar a retenção' : undefined}
            className={`px-4 py-2 rounded-lg text-sm disabled:opacity-50 ${acaoPrincipal}`}>
            {enviando ? 'Aprovando…' : 'Liberar e aprovar'}
          </button>
        </>
      }
    >
      {motivoDaRetencao && (
        <p className={`text-sm rounded-lg border px-3 py-2 ${TONE_SURFACE.warning} ${TONE_BORDER.warning} ${TONE_TEXT.warning}`}>🔒 Retida: {motivoDaRetencao}</p>
      )}
      {aviso && <p className='text-xs text-slate-400'>{aviso}</p>}
      <p className='text-xs text-slate-400'>A fatura muda de Rascunho para Aberta. O motivo e quem liberou ficam gravados na fatura.</p>
      <CampoDoMotivoDaLiberacao valor={motivo} onChange={setMotivo} />
      <RecusaDoServidor erro={erro} />
    </CascaDeModal>
  );
}
